/**
 * Maps an axios error from POST /api/forms/submit into a user-facing toast message.
 * Centralised so every FormModal handles the 409 duplicate-submission case identically.
 *
 * @param {unknown} error  - axios catch payload
 * @param {boolean} isEdit - true when editing an existing submission (uses 更新 wording)
 * @returns {string}       - the message to pass to toast.error(...)
 */
export function formatSubmitError(error, isEdit = false) {
  const detail = error?.response?.data?.detail;
  if (error?.response?.status === 409 && detail && typeof detail === 'object' && detail.message) {
    return detail.message;
  }
  if (typeof detail === 'string') return detail;
  return isEdit ? '更新に失敗しました' : '登録に失敗しました';
}
